import React, { useState } from "react";
import styled from "styled-components";
import Financials from "./financials";
import { Row, Col } from "components/shared/layout";
import Button from "components/button";
import Select from "components/select";
import Layout, { Header } from "../../shared/card-layout";
import { connect } from "formik";
import Modal, { ModalContent, ModalContext } from "components/modal";
import DropZone from "components/dropzone";
import UploadedFile from "components/uploaded-file";
import TextArea from "components/textarea";

const FormsContainer = styled.div`
  width: 100%;
`;

const QuestionGroup = styled(Row)`
  margin-bottom: 50px;
`;

const FieldWrapper = styled(Col)`
  padding: 10px;
`;

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

const uploadType = {
  logo: 'logo_proof',
  marketing_plan :'marketing_plan_proof',
  social_media_strategy: 'social_media_strategy_proof',
  roi_strategy: 'roi_strategy_proof',
  client_satisfaction_procedure: 'client_satisfaction_procedure_proof',
  client_relationship_program: 'client_relationship_program_proof',
  sales_targets: 'sales_targets_proof',
};

const MarketingFormLevel1 = connect(({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Do you have a mission statement?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_mission_statement"
                  placeholder={"Mission Statement?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
              <FieldWrapper md={6}>
                <TextArea
                  style={{ minHeight: 200, minWidth: 500 }}
                  name="mission_statement"
                  placeholder="Enter your mission statement"
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Do you have a marketing plan?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_marketing_plan"
                  placeholder={"Marketing Plan?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organization have an ROI strategy' subtitle='(sales, profit margins)' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_roi_strategy"
                  placeholder={"ROI Strategy?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organization have a client satisfaction procedure' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_client_satisfaction_procedure"
                  placeholder={"Client Satisfaction Procedure?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organization have a client relationship management program?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_client_relationship_program"
                  placeholder={"Client Relationship Program?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organization have sales targets?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_sales_targets"
                  placeholder={"Sales Targets?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Do you have a logo?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_logo"
                  placeholder={"Logo?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organization have a social media strategy' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_social_media_strategy"
                  placeholder={"Social Media Strategy?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
});


const MarketingFormLevel2 = connect(({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload your marketing plan' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.marketing_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.marketing_plan_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.marketing_plan_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("marketing_plan_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.marketing_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.marketing_plan)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.marketing_plan && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>

            <QuestionGroup xs={12}>
              <Header title='Upload your ROI strategy' subtitle='(sales, profit margins)' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.roi_strategy_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.roi_strategy_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.roi_strategy_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("roi_strategy_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.roi_strategy_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.roi_strategy)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.roi_strategy && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>

            <QuestionGroup xs={12}>
              <Header title='Upload your client satisfaction procedure' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.client_satisfaction_procedure_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.client_satisfaction_procedure_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.client_satisfaction_procedure_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("client_satisfaction_procedure_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.client_satisfaction_procedure_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.client_satisfaction_procedure)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.client_satisfaction_procedure && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>

        <Col xs={12} lg={6} style={{ height: 'fit-content'}}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of your client relationship management program?' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.client_relationship_program_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.client_relationship_program_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.client_relationship_program_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("client_relationship_program_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.client_relationship_program_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.client_relationship_program)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.client_relationship_program && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>

            <QuestionGroup xs={12}>
              <Header title='Upload proof of your sales targets?' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.sales_targets_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.sales_targets_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.sales_targets_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("sales_targets_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.sales_targets_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.sales_targets)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.sales_targets && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of logo' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.logo_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.logo_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.logo_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("logo_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.logo_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.logo)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.logo && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload your social media strategy' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.social_media_strategy_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.social_media_strategy_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.social_media_strategy_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("social_media_strategy_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.social_media_strategy_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.social_media_strategy)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.social_media_strategy && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
});

export {
  MarketingFormLevel1,
  MarketingFormLevel2
};
